import styled from "styled-components";

export const HeaderText = styled.span`
  font-weight: 600;
  font-size: 16px;
`;
